import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { IHttpService } from '@services/HttpService';
import { WorkStatus } from '@models/onboarding-review/section2-document-upload';
import { I9DocumentTypesEnum, I9DocumentInfoDto } from '@swipejobs/i9-document-validations-react';
import convertDocumentListToMap from '@utils/map-document-validation';
import { RequireAuthenticationToken } from '@services/http/authorisation-interceptor';

export interface IDocumentUploadValidationApiService {
    getDocumentDetailsByCitizenship(workStatus: WorkStatus): Promise<I9DocumentResultType | any>;
}

export type I9DocumentResultType = Partial<Record<I9DocumentTypesEnum, I9DocumentInfoDto>>;

export class DocumentUploadValidationApiService implements IDocumentUploadValidationApiService {
    constructor(
        private httpService: IHttpService,
        private configurationValuesService: IConfigurationValuesService
    ) {
    }

    @RequireAuthenticationToken
    async getDocumentDetailsByCitizenship(workStatus: WorkStatus): Promise<I9DocumentResultType> {
        const result = await this.httpService.get<I9DocumentInfoDto[]>(
            `${this.configurationValuesService.apiUrl}/worker-onboarding/external/representative/document/validation/citizenship/${workStatus}`,
        )
        return convertDocumentListToMap(result?.data);
    }
}



// WEBPACK FOOTER //
// ./src/services/document-upload-validation-api-service.ts